import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white h-screen min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8 dark:bg-neutral-600" }
const _hoisted_2 = { class: "max-w-max mx-auto" }
const _hoisted_3 = { class: "sm:flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-4xl font-extrabold text-chat-primary sm:text-5xl" }, " Ops ", -1)
const _hoisted_5 = { class: "sm:ml-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sm:border-l sm:border-gray-200 sm:pl-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-extrabold text-chat-gray-dark tracking-tight sm:text-5xl dark:text-white" }, " Página não encontrada! "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-base text-chat-gray dark:text-gray-300" }, " Desculpe-nos, mas não localizamos a página que tentou acessar. ")
], -1)
const _hoisted_7 = { class: "mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Voltar ")


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

    function goToHome() {
        window.location.href = window.location.origin
    }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass([
                                'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md  text-white bg-chat-primary shadow-md shadow-chat-primary chat_shadow',
                                'hover:shadow-none hover:text-white focus:outline-none focus:shadow-none focus:ring-2 focus:ring-offset-2 focus:ring-chat-primary',
                                'dark:focus:ring-offset-neutral-600'
                            ]),
              onClick: goToHome
            }, " Página inicial "),
            _createVNode(_component_RouterLink, {
              to: "",
              class: _normalizeClass([
                                'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-chat-primary-dark bg-chat-primary/20',
                                'hover:bg-chat-primary/40 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-chat-primary focus:bg-chat-primary/40',
                                'dark:focus:ring-offset-neutral-600 dark:focus:text-white dark:hover:text-white dark:text-gray-300'
                            ]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent","stop"]))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})